{
  "toasts": {
    "created": "Webhook created successfully!",
    "createError": "Failed to create webhook",
    "updated": "Webhook updated successfully!",
    "updateError": "Failed to update webhook",
    "deleted": "Webhook deleted successfully!",
    "deleteError": "Failed to delete webhook",
    "testSent": "Test webhook sent!",
    "testError": "Failed to send test webhook"
  },
  "webhooks": {
    "events": {
      "userCreated": "Member created",
      "userUpdated": "Member updated",
      "enrollmentCreated": "Enrollment created",
      "enrollmentRemoved": "Enrollment removed",
      "lessonCompleted": "Lesson completed",
      "courseCompleted": "Course completed",
      "paymentApproved": "Payment approved",
      "paymentRefunded": "Payment refunded"
    },
    "validation": {
      "nameRequired": "Enter the webhook name",
      "urlRequired": "Enter the webhook URL",
      "eventsRequired": "Select at least one event"
    },
    "secretCopied": "Secret copied to clipboard",
    "subtitle": "Manage webhooks to integrate with external systems",
    "new": "New webhook",
    "active": "Active",
    "inactive": "Inactive",
    "eventCount_one": "{{count}} event",
    "eventCount_zero": "{{count}} events",
    "eventCount_other": "{{count}} events",
    "actions": {
      "viewLogs": "View logs",
      "sendTest": "Send test",
      "copySecret": "Copy secret",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create"
    },
    "empty": {
      "title": "No webhooks yet",
      "description": "Create your first webhook to integrate with external systems"
    },
    "form": {
      "editTitle": "Edit webhook",
      "editDescription": "Update the webhook settings.",
      "createDescription": "Set up a new webhook to receive event notifications.",
      "name": "Name",
      "namePlaceholder": "E.g. Zapier notification",
      "urlPlaceholder": "https://example.com/webhook",
      "events": "Events",
      "activeHint": "When disabled, no deliveries will be made"
    },
    "delete": {
      "title": "Delete webhook",
      "description": "Are you sure you want to delete the webhook <bold>{{name}}</bold>? This action cannot be undone and all delivery logs will be removed."
    },
    "logs": {
      "title": "Logs - {{name}}",
      "description": "Recent deliveries for this webhook",
      "event": "Event",
      "status": "Status",
      "code": "Code",
      "date": "Date",
      "ok": "OK",
      "failed": "Failed",
      "pagination_one": "Page {{page}} of {{totalPages}} ({{count}} record)",
      "pagination_zero": "Page {{page}} of {{totalPages}} ({{count}} records)",
      "pagination_other": "Page {{page}} of {{totalPages}} ({{count}} records)",
      "previous": "Previous",
      "next": "Next",
      "empty": "No logs found for this webhook"
    }
  }
}
